export default __webpack_public_path__ + "static/media/Mark-5-Blueprints-00.c3ca6dda.jpg";